import { render, staticRenderFns } from "./EducationSection.vue?vue&type=template&id=53c12c10&"
import script from "./EducationSection.vue?vue&type=script&lang=js&"
export * from "./EducationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports